import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { DoctorSearchResponse } from '../models/doctor-search-response.model';
import { InviteDoctorRequest } from '../models/invite-doctor-request.model';
import { PendingInvitationResponse } from '../models/pending-invitation-response.model';

@Injectable({
  providedIn: 'root',
})
export class DoctorInvitationService {
  private apiUrl = environment.APP_BASE_URL + '/clinic-portal/doctor-invitation';

  constructor(private http: HttpClient) {}

  public searchDoctorByCode(invitationCode: string): Observable<DoctorSearchResponse> {
    return this.http.get<DoctorSearchResponse>(`${this.apiUrl}/search`, {
      params: { invitationCode },
    });
  }

  public inviteDoctor(request: InviteDoctorRequest): Observable<boolean> {
    return this.http.post<boolean>(`${this.apiUrl}/invite`, request);
  }

  public getPendingInvitations(clinicId: string): Observable<PendingInvitationResponse[]> {
    return this.http.get<PendingInvitationResponse[]>(`${this.apiUrl}/pending/${clinicId}`);
  }
}
